import React from 'react';
import { useSearchParam } from '../useSearchParam';

export function useShouldUseContentEntryFallbacks() {
  const contentEntryFallbacksOverride = useSearchParam('contentEntryFallbacks');
  return React.useMemo(() => {
    if (contentEntryFallbacksOverride != null) {
      return contentEntryFallbacksOverride === 'true';
    }
    if (typeof import.meta.env.REACT_APP_USE_CONTENT_ENTRY_FALLBACKS !== 'undefined') {
      return import.meta.env.REACT_APP_USE_CONTENT_ENTRY_FALLBACKS === 'true';
    }
    // Default to true if not set
    return true;
  }, [contentEntryFallbacksOverride]);
}
